module.exports = __webpack_public_path__ + "static/media/mw.bb3d04fb.svg";